const CEZY_API_BASE_URL = 'https://lupsa-api.registre.ro/smartland-api'
const AZURE_AD_CLIENT_ID = '1b4d87d0-6585-4550-8147-e946e81a923a'
const AZURE_AD_AUTHORITY =
  'https://login.microsoftonline.com/d4a56650-d1ad-4a00-b294-b7f228c50a27'

export default class Constants {
  static get CEZY_API_BASE_URL() {
    return CEZY_API_BASE_URL
  }

  static get AZURE_AD_CLIENT_ID() {
    return AZURE_AD_CLIENT_ID
  }

  static get AZURE_AD_AUTHORITY() {
    return AZURE_AD_AUTHORITY
  }
}
